export const nover = [
  '512 512',
  `
  <title>Visualizar</title>
  <g id="Capa_x0020_1">
    <g id="_693778808">
    <g>
      <path fill="#d8dbe0" d="M252,146.236a89.829,89.829,0,0,0-23.154,3.025L338.975,259.39A90.014,90.014,0,0,0,252,146.236Z"></path>
      <path fill="#d8dbe0" d="M397.222,123.1l-.218-.222C334.515,60.389,240.535,48.138,165.682,86.1l35.051,35.052A125.98,125.98,0,0,1,367.088,287.5L416.7,337.117,496,254.683V225.79Z"></path>
      <path fill="#d8dbe0" d="M16,16V45.012l88.636,88.636L16,225.79v28.893l98.778,102.689.218.222a199.8,199.8,0,0,0,243.591,30L466.988,496H496V465.616L46.384,16ZM143.4,172.413l26.644,26.644A89.989,89.989,0,0,0,289.179,318.192l26.644,26.643A125.945,125.945,0,0,1,143.4,172.413Z"></path>
    </g>
    </g>
  </g>
  `,
]
